import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { selectUser } from '../store';
import { MyUserViewModel } from '../services';

export const useMyUser = () => {
  const { user } = useSelector(selectUser);

  return useMemo(() => {
    if (!user) return null;

    // Not sure with this solution.
    // View model keeps some extra logic
    const userVm = new MyUserViewModel();
    userVm.id = user.id;
    userVm.roles = user.roles ?? [];
    userVm.orgID = user.orgID;
    userVm.email = user.email;
    userVm.userName = user.userName;

    return userVm;
  }, [user]);
};
